import { render } from "./TestTube.vue?vue&type=template&id=4d7c878e"
import script from "./TestTube.vue?vue&type=script&lang=js"
export * from "./TestTube.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__